import type {ReactNode} from 'react';
import {Box, Group} from '@mantine/core';

export interface StickyFooterProps {
  children: ReactNode;
}

/**
 * Sticky bottom action bar with right-aligned actions.
 * @registry Sticky bottom action bar for right-aligned page-level actions.
 */
export const StickyFooter = ({children}: StickyFooterProps) => (
  <Box
    pos="sticky"
    bottom={0}
    py="sm"
    style={{
      zIndex: 10,
      background: 'var(--mantine-color-body)',
      borderTop: '1px solid var(--mantine-color-gray-3)',
    }}>
    <Group justify="end">{children}</Group>
  </Box>
);
